import { trendingItems } from "@/mocks/categories";

export default function TrendingSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            Trending Now
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            Most popular items being compared right now on Pandabuy Sheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {trendingItems.map((item) => (
            <a
              key={item.name}
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300/60 transition-all duration-200 cursor-pointer"
            >
              <div className="relative">
                {item.badge && (
                  <span className="absolute top-3 left-3 z-10 px-2.5 py-0.5 text-xs font-semibold rounded-full bg-accent-500 text-white">
                    {item.badge}
                  </span>
                )}
                <div className="w-full aspect-[4/5] overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.name}
                    title={item.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </div>
              <div className="p-4 text-center">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950">
                  {item.name}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{item.price}</p>
                <span className="inline-flex items-center gap-1 mt-2 text-xs font-medium text-accent-600">
                  Compare on Sheet
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}